export default "__VITE_ASSET__DnX37yOY__"